import Box from '@mui/material/Box';
import Checkbox from '@mui/material/Checkbox';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormGroup from '@mui/material/FormGroup';
import FormHelperText from '@mui/material/FormHelperText';
import FormLabel from '@mui/material/FormLabel';
import Radio from '@mui/material/Radio';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';
import React from 'react';
import {
  CheckboxCheckedIcon,
  CheckboxIcon,
  CheckboxIntermediateIcon,
} from '../icons';

export const CheckboxBase = (props) => (
  <Checkbox
    indeterminateIcon={<CheckboxIntermediateIcon />}
    icon={<CheckboxIcon sx={{ color: 'dividerVariant' }} />}
    checkedIcon={<CheckboxCheckedIcon />}
    {...props}
  />
);

const CustomCheckBox = React.forwardRef(
  (
    {
      id,
      name,
      value,
      heading,
      label = '',
      hasError,
      helpText,
      hint,
      checked,
      onChange,
      className,
      size,
      type,
      margin,
      labelPlacement,
      indeterminate,
      sx,
      disabled,
      disableGutters,
    },
    ref,
  ) => {
    // const Component = type === 'radio' ? Radio : Checkbox;

    const control = (
      <CheckboxBase
        indeterminateIcon={<CheckboxIntermediateIcon />}
        icon={<CheckboxIcon sx={{ color: 'dividerVariant' }} />}
        checkedIcon={<CheckboxCheckedIcon />}
        size={size}
        color="primary"
        name={name}
        checked={checked || false}
        onChange={onChange}
        value={value}
        indeterminate={indeterminate}
        disableRipple
        sx={disableGutters && { padding: 0 }}
      />
    );

    return (
      <Box className={className}>
        <FormControl
          error={hasError}
          variant="standard"
          ref={ref}
          margin={margin}
          sx={sx}
          disabled={disabled}
          size={size}
        >
          {heading && <FormLabel>{heading}</FormLabel>}
          <FormGroup>
            {label ? (
              <FormControlLabel
                sx={{ ml: 0.5 }}
                labelPlacement={labelPlacement}
                control={control}
                label={label}
              />
            ) : (
              control
            )}
          </FormGroup>
          {hasError && <FormHelperText>{helpText}</FormHelperText>}
          {hint && (
            <Typography variant="caption" color="textSecondary">
              {hint}
            </Typography>
          )}
        </FormControl>
      </Box>
    );
  },
);

CustomCheckBox.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.string,
  heading: PropTypes.string,
  label: PropTypes.string,
  hasError: PropTypes.bool,
  helpText: PropTypes.string,
  hint: PropTypes.string,
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  className: PropTypes.string,
  size: PropTypes.oneOf(['small', 'medium']),
  margin: PropTypes.oneOf(['none', 'dense', 'normal']),
  labelPlacement: PropTypes.oneOf(['end', 'start']),
  indeterminate: PropTypes.bool,
  sx: PropTypes.object,
  disabled: PropTypes.bool,
  disableGutters: PropTypes.bool,
};

export default CustomCheckBox;
